import { useEffect, useState } from "react";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import Select from "../../../../components/Select";
import { CommonService } from "../../../../services/CommonService";
import { translateAndSortAscendant } from "../../../../common/helper";

export default function CandidateSource({ searchObject, onChange, t }) {
  const [candidateSources, setCandidateSources] = useState([]);

  useEffect(() => {
    CommonService.getCandidateSources().then((data) => {
      setCandidateSources(translateAndSortAscendant(data, "description"));
    });
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Source")}</legend>{" "}
      <Select
        className="form-select fontsize-legend"
        name="candidateSourceId"
        onChange={onChange}
        value={searchObject.candidateSourceId || ""}
      >
        <option value=""></option>
        {candidateSources.map((option) => (
          <option className="fontsize-legend" value={option.id}>
            {t(option.description)}
          </option>
        ))}
      </Select>
    </div>
  );
}
